import React from 'react';

import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import {
  Stack,
  Typography,
} from '@mui/material';

import ProfileIcon from '../ProfileIcon';
import { ColorHex } from '../ProfileIcon/types';

import { RankTypography, StyledCard } from './index.styles';

interface LeaderboardRowProps {
  firstName: string,
  lastName: string,
  profileIcon?: {
    color?: ColorHex,
    image?: string,
  },
  rank: number,
  points: number,
  isCurrentUser?: boolean,
}

const LeaderboardRow = ({
  firstName,
  lastName,
  profileIcon,
  rank,
  points,
  isCurrentUser = false,
}: LeaderboardRowProps) => (
  <StyledCard $isCurrentUser={isCurrentUser}>
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
    >
      <RankTypography $rank={rank} fontWeight="bold">
        {rank}
        {rank === 1 && <EmojiEventsIcon />}
        {(rank === 2 || rank === 3) && <WorkspacePremiumIcon />}
      </RankTypography>

      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
      >
        <ProfileIcon
          firstName={firstName}
          lastName={lastName}
          color={profileIcon?.color}
          imageUrl={profileIcon?.image}
          size={36}
        />
        <Typography fontWeight="bold">
          {firstName} {lastName}
        </Typography>
      </Stack>
    </Stack>
    <Typography>
      {points}
    </Typography>
  </StyledCard>
);
export default LeaderboardRow;
